import React from 'react';
import PropTypes from 'prop-types';

import './Legend.scss';

import {
  attributeOptions,
  formatNumber,
  getAttributeText,
} from '../../Utilities/Helpers';

// const BACK_IMG = `linear-gradient(
//   270deg,
//   hsla(0,100%,50%,0.95) 0%,
//   hsla(0,100%,50%,0.95) 6%,
//   hsla(10,100%,50%,0.95) 6%,
//   hsla(10,100%,50%,0.95) 19%,
//   hsla(20,100%,50%,0.95) 19%,
//   hsla(20,100%,50%,0.95) 31%,
//   hsla(30,100%,50%,0.95) 31%,
//   hsla(30,100%,50%,0.95) 44%,
//   hsla(40,100%,50%,0.95) 44%,
//   hsla(40,100%,50%,0.95) 56%,
//   hsla(40,75%,50%,0.95) 56%,
//   hsla(40,75%,50%,0.95) 69%,
//   hsla(40,50%,50%,0.95) 69%,
//   hsla(40,50%,50%,0.95) 81%,
//   hsla(40,25%,50%,0.95) 81%,
//   hsla(40,25%,50%,0.95) 94%,
//   hsla(40,0%,50%,0.95) 94%,
//   hsla(40,0%,50%,0.95) 100%
//   )`;

const BACK_IMG = `linear-gradient(
  270deg,
  hsla(0,100%,50%,0.95) 0%,
  hsla(0,100%,50%,0.95) 6%,
  hsla(10,100%,50%,0.95) 6%,
  hsla(10,100%,50%,0.95) 19%,
  hsla(20,100%,50%,0.95) 19%,
  hsla(20,100%,50%,0.95) 31%,
  hsla(30,100%,50%,0.95) 31%,
  hsla(30,100%,50%,0.95) 44%,
  hsla(39.83, 99.16%, 53.53%,0.95) 44%,
  hsla(39.83, 99.16%, 53.53%,0.95) 56%,
  hsla(39.3, 92.43%, 63.73%,0.95) 56%,
  hsla(39.3, 92.43%, 63.73%,0.95) 69%,
  hsla(39.13, 86.47%, 73.92%,0.95) 69%,
  hsla(39.13, 86.47%, 73.92%,0.95) 81%,
  hsla(37.85, 80.25%, 84.12%,0.95) 81%,
  hsla(37.85, 80.25%, 84.12%,0.95) 94%,
  hsla(40,0%,50%,0.95) 94%,
  hsla(40,0%,50%,0.95) 100%
  )`;

export default function Legend({
  mode,
  mapColorRange,
  climateOption,
  hazardOptions,
  cbFriendly,
  isCountyLevel,
}) {
  let legendLowerColor, legendMidColor, legendUpperColor, titleText;
  let max = 0;
  let min = 0;
  let binned = false;

  const { unit } = getAttributeText(
    mode,
    mode ? climateOption : hazardOptions[1]
  );

  if (mapColorRange) {
    // max = formatNumber(mapColorRange.max);
    const range = isCountyLevel ? mapColorRange.county : mapColorRange.state;
    min = formatNumber(range.min);
    max = formatNumber(range.max);
  }

  if (mode) {
    const thisAttrOptions = attributeOptions[climateOption];

    if (thisAttrOptions.precip) {
      legendLowerColor = cbFriendly
        ? ['hsla(0,100%,100%,0.95)', 'hsla(103,63.8%,41.2%,0.95)']
        : ['hsla(135,100%,75%,0.95)', 'hsla(135,100%,0%,0.95)'];
      legendMidColor = 'hsla(0,100%,100%,0.95)';
      legendUpperColor = cbFriendly
        ? ['hsla(0,100%,100%,0.95)', 'hsla(323,76.3%,46.3%,0.95)']
        : ['hsla(40,100%,75%,0.95)', 'hsla(40,100%,0%,0.95)'];
    } else {
      if (climateOption.includes('cntlt')) {
        legendLowerColor = [
          'hsla(210,100%,90%,0.95)',
          'hsla(210,100%,25%,0.95)',
        ];
        legendMidColor = 'hsla(0,100%,100%,0.95)';
        legendUpperColor = ['hsla(0,100%,90%,0.95)', 'hsla(0,100%,25%,0.95)'];
      } else {
        legendLowerColor = ['hsla(0,100%,90%,0.95)', 'hsla(0,100%,25%,0.95)'];
        legendMidColor = 'hsla(0,100%,100%,0.95)';
        legendUpperColor = [
          'hsla(210,100%,90%,0.95)',
          'hsla(210,100%,25%,0.95)',
        ];
      }
    }

    if (thisAttrOptions['dayUnits']) {
      titleText = `Trend (${unit.slice(10, 14)}/Decade)`;
    } else {
      titleText = `${unit.charAt(0).toUpperCase() + unit.slice(1, -1)}/Decade)`;
    }
  } else {
    binned = hazardOptions[1].includes('damage') ? true : false;
    titleText = unit.charAt(0).toUpperCase() + unit.slice(1);

    legendLowerColor = ['hsla(40,51%,50%,0.95)', 'hsla(40,100%,50%,0.95)'];
    legendMidColor = 'hsla(40,50%,50%,0.95)';
    legendUpperColor = ['hsla(40,49%,50%,0.95)', 'hsla(40,0%,50%,0.95)'];
  }

  return (
    <div className='legend-controls-container'>
      {max === 0 || max === '0' ? (
        <div id='no-legend'>No occurances reported</div>
      ) : (
        <div id='legend-wrapper'>
          <div id='legend'>
            {binned ? (
              <div
                id='legend-color'
                style={{
                  backgroundImage: BACK_IMG,
                }}
              >
                <div id='dividers'>
                  <div className='divider'></div>
                  <div className='divider'></div>
                  <div className='divider'></div>
                  <div className='divider'></div>
                  <div className='divider'></div>
                  <div className='divider'></div>
                  <div className='divider'></div>
                  <div className='divider'></div>
                </div>
              </div>
            ) : (
              <>
                <div
                  id='legend-color-lower'
                  style={{
                    background: `linear-gradient(270deg,
                    ${legendMidColor} 0%,
                    ${legendUpperColor[0]} 1%,
                    ${legendUpperColor[1]} 100%)`,
                  }}
                ></div>

                <div
                  id='legend-color-upper'
                  style={{
                    background: `linear-gradient(270deg,${legendLowerColor[1]} 0%,
                    ${legendLowerColor[0]} 99%,
                    ${legendMidColor} 100%)`,
                  }}
                ></div>
              </>
            )}
          </div>

          {binned ? (
            <div id='legend-units'>
              {/* <div className="binned-legend-text zero">$0</div> */}
              <div className='binned-legend-text one'>
                <span>$</span>1
              </div>
              <div className='binned-legend-text two'>
                <span>$</span>1k
              </div>
              <div className='binned-legend-text three'>
                <span>$</span>10k
              </div>
              <div className='binned-legend-text four'>
                <span>$</span>100k
              </div>
              <div className='binned-legend-text five'>
                <span>$</span>1M
              </div>
              <div className='binned-legend-text six'>
                <span>$</span>10M
              </div>
              <div className='binned-legend-text seven'>
                <span>$</span>100M
              </div>
              <div className='binned-legend-text eight'>
                <span>$</span>1B
              </div>
              {/* <div className="binned-legend-text nine">$1B+</div> */}
            </div>
          ) : (
            <div id='legend-units'>
              <div id='legend-title'>{titleText}</div>
              <div className='legend-text'>{min}</div>
              {mode && <div className='legend-text'>0</div>}
              <div className='legend-text'>{max}</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

Legend.propTypes = {
  mode: PropTypes.bool,
  mapColorRange: PropTypes.object,
  climateOption: PropTypes.string,
  hazardOptions: PropTypes.array,
  cbFriendly: PropTypes.bool,
  isCountyLevel: PropTypes.bool,
};
